import React, { Component } from 'react';
import moment from 'moment';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Calendar from './Calendar';

class CalendarExample extends Component {

  constructor() {
    super();
    this.state = {
      selected: moment(),
      utcOffset: 0,
      errorMessage: <div>I shudder to think what would happen if you pick that.</div>,
      onClearNotice: e => { this.setState( {errorMessage: ""} ); },
    };
  }

  onChange = date => this.setState({ selected: date ? date.clone() : null });

  onPropChange = e => this.setState(e.target.value);

  filtered = e => {
    const included = [moment(), moment().add(1, 'days')];

    for (let i = 0; i < included.length; i++) {
      if (e.isSame(included[i], 'day')) {
        return true;
      }
    }
    return false;
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={Calendar.defaultProps} onChange={this.onPropChange} propTypes={Calendar.propTypes} propValues={this.state}>
          <Tip>Try setting <em>className</em> to <span className="string">light-header</span> to change the header color.</Tip>
        </Properties>
        <div className="calendar-container">
          <Calendar {...this.state} onSelect={this.onChange}/>
        </div>
        <SourceCode querySelector=".calendar-example .calendar-container .core-calendar"/>
        <SourceCode language="javascript" title="The onSelect callback">
          {
            '/* For the Calendar view to be updated the onSelect and selected prop must be implemented. Example: */\n' +
            'constructor() {\n' +
            '  this.state = { selected: moment() }\n' +
            '}\n' +
            '\n' +
            'onSelect(date) {\n' +
            '  // the date parameter is a moment object\n' +
            '  this.setState({ selected: date })\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<Calendar onSelect={this.onSelect.bind(this)} selected={this.state.selected}/>);\n' +
            '}'
          }
        </SourceCode>
        <SourceCode language="javascript" title="Locale and utcOffset props">
          {
            '/* The Calendar is default set to utc.\n' +
            ' * For a different timezone use the utcOffset prop.\n' +
            ' * For language and start of week set the locale prop. */\n' +
            'render() {\n' +
            '  const localUtcOffset = moment().utcOffset(); //Use the computer\'s local timezone \n' +
            '  const local = moment().locale(); \n' +
            '  return (<Calendar utcOffset={localeUtcOffset} locale={local}/>);\n' +
            '}'
          }
        </SourceCode>
        <SourceCode language="javascript" title="Filtered and highlighted props">
          {
            '/* See http://momentjs.com/docs/#/query/ for more Moment JS queries methods */\n' +
            '// Highlighted moments example\n' +
            'highlight(date) {\n' +
            ' return date.isBetween(moment(), moment().add(5, \'days\'));\n' +
            '}\n' +
            '\n' +
            '// Filtered moments example\n' +
            'isWeekday(date) {\n' +
            ' return date.day() !== 0 && date.day() !== 6;\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<Calendar onSelect={this.onSelect.bind(this)} selected={this.state.selected} filtered={this.isWeekday} highlighted={this.highlight}/>);\n' +
            '}'
          }
        </SourceCode>
      </Example>
    );
  }

}

CalendarExample.tags = 'date';

export default CalendarExample;
